export const DEFAULT_LOCALE = 'es-CR';
export const DEFAULT_TIME_ZONE = 'America/Costa_Rica';

export function resolveTimeZone(timeZone?: string | null) {
  const candidate =
    String(timeZone || '').trim() ||
    Intl.DateTimeFormat().resolvedOptions().timeZone ||
    DEFAULT_TIME_ZONE;
  try {
    Intl.DateTimeFormat(DEFAULT_LOCALE, { timeZone: candidate }).format(new Date());
    return candidate;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

export function formatNumber(value: number, decimals = 0) {
  return Number(value || 0).toLocaleString(DEFAULT_LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatCurrencyCRC(value: number) {
  return `CRC ${formatNumber(value, 2)}`;
}

export function formatDateTimeCR(value?: string | number | Date | null, timeZone?: string | null) {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString(DEFAULT_LOCALE, {
    timeZone: resolveTimeZone(timeZone),
  });
}

export function getTodayRangeIso(timeZone?: string | null) {
  const tz = resolveTimeZone(timeZone);
  const now = new Date();
  const zonedNow = new Date(now.toLocaleString('en-US', { timeZone: tz }));
  const start = new Date(zonedNow);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(start.getDate() + 1);
  return { startIso: start.toISOString(), endIso: end.toISOString() };
}

export function getCurrentWeekRangeIso(timeZone?: string | null) {
  const tz = resolveTimeZone(timeZone);
  const now = new Date();
  const zonedNow = new Date(now.toLocaleString('en-US', { timeZone: tz }));
  const day = zonedNow.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const start = new Date(zonedNow);
  start.setDate(zonedNow.getDate() + diffToMonday);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(start.getDate() + 7);
  return { startIso: start.toISOString(), endIso: end.toISOString() };
}
